import { render, staticRenderFns } from "./rfq-import-quote-pdf.vue?vue&type=template&id=b1d70b3a&scoped=true"
import script from "./rfq-import-quote-pdf.vue?vue&type=script&lang=js"
export * from "./rfq-import-quote-pdf.vue?vue&type=script&lang=js"
import style0 from "./rfq-import-quote-pdf.vue?vue&type=style&index=0&id=b1d70b3a&prod&scoped=true&lang=css"
import style1 from "./rfq-import-quote-pdf.vue?vue&type=style&index=1&id=b1d70b3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d70b3a",
  null
  
)

export default component.exports